import { Plugin } from '@ckeditor/ckeditor5-core';
import { toWidget } from '@ckeditor/ckeditor5-widget';
import InsertRelatedExampleCommand from './related-example-command';
export default class RelatedExampleEditing extends Plugin {
    init() {
        this.editor.commands.add('insertRelatedExample', new InsertRelatedExampleCommand(this.editor));
        this._defineSchema();
        this._defineConverters();
    }
    _defineSchema() {
        const schema = this.editor.model.schema;
        schema.register('relatedExample', {
            isObject: true,
            allowWhere: '$block',
            allowAttributes: 'exampleId',
        });
        schema.register('relatedExampleTitle', {
            isLimit: true,
            allowIn: 'relatedExample',
            allowContentOf: '$block',
        });
        schema.register('relatedExampleDescription', {
            isLimit: true,
            allowIn: 'relatedExample',
            allowContentOf: '$block',
        });
    }
    _defineConverters() {
        try {
            const conversion = this.editor.conversion;
            // Related example container
            conversion.for('upcast').elementToElement({
                model: (viewElement, { writer }) => {
                    return writer.createElement('relatedExample', {
                        exampleId: viewElement.getAttribute('data-example-id'),
                    });
                },
                view: { name: 'x-related-example' },
            });
            conversion.for('dataDowncast').elementToElement({
                model: 'relatedExample',
                view: (modelElement, { writer }) => {
                    return writer.createContainerElement('x-related-example', {
                        'data-example-id': modelElement.getAttribute('exampleId'),
                    });
                },
            });
            conversion.for('editingDowncast').elementToElement({
                model: 'relatedExample',
                view: (model, { writer }) => {
                    const element = writer.createContainerElement('div', {
                        class: 'related-example',
                        'data-example-id': model.getAttribute('exampleId'),
                    });
                    return toWidget(element, writer, { label: 'related example' });
                },
            });
            // Related example title
            conversion.for('upcast').elementToElement({
                model: 'relatedExampleTitle',
                view: 'x-related-example-title',
            });
            conversion.for('dataDowncast').elementToElement({
                model: 'relatedExampleTitle',
                view: 'x-related-example-title',
            });
            conversion.for('editingDowncast').elementToElement({
                model: 'relatedExampleTitle',
                view: (model, { writer }) => {
                    const element = writer.createContainerElement('div', {
                        class: 'related-example__title',
                    });
                    return element;
                },
            });
            // Related example description
            conversion.for('upcast').elementToElement({
                model: 'relatedExampleDescription',
                view: 'x-related-example-description',
            });
            conversion.for('dataDowncast').elementToElement({
                model: 'relatedExampleDescription',
                view: 'x-related-example-description',
            });
            conversion.for('editingDowncast').elementToElement({
                model: 'relatedExampleDescription',
                view: (model, { writer }) => {
                    const element = writer.createContainerElement('div', {
                        class: 'related-example__description',
                    });
                    return element;
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
}
